// "Research this" (spec walkthrough 2, D3): the board task the browser
// creates through the existing tasks API, then links to the company.
import { companyPath } from "./format";
import { displayName } from "../../tasks/userDisplay";

/** The board convention's title (spec §7). */
export function researchTaskTitle(symbol) {
  return `Investing: research ${symbol}`;
}

/**
 * The task's description: what to research, the person's question (when
 * they asked one — the procedure says it's what the work answers), and a
 * link back to the company's page.
 */
export function researchTaskDescription({ symbol, name, question, origin }) {
  const who = name ? `${symbol} (${name})` : symbol;
  const parts = [
    `Research ${who} for the Investing desk. The procedure is ` +
      `"Investing: research <SYMBOL>" in the mono-mcp-workflows skill (investing.md).`,
  ];
  const asked = (question || "").trim();
  if (asked) parts.push(`Question: ${asked}`);
  parts.push(`Company page: ${origin}${companyPath(symbol)}`);
  return parts.join("\n\n");
}

/**
 * The agents a person can ask for research: their own, active ones. Research
 * an agent records is filed under the agent's person (library_owner), so
 * another person's agent — or an ownerless one — would file it elsewhere.
 */
export function myAgents(agents, me) {
  if (!me || !Array.isArray(agents)) return [];
  return agents
    .filter((agent) => agent.is_active && agent.owner?.id === me.id)
    .sort((a, b) => displayName(a).localeCompare(displayName(b)));
}
